import { render, staticRenderFns } from "./TableErrorBondSold.vue?vue&type=template&id=54faeeff&scoped=true"
import script from "./TableErrorBondSold.vue?vue&type=script&lang=js"
export * from "./TableErrorBondSold.vue?vue&type=script&lang=js"
import style0 from "./TableErrorBondSold.vue?vue&type=style&index=0&id=54faeeff&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faeeff",
  null
  
)

export default component.exports